import { ApiErrorDTO } from "@bvhi/backend-api/apis";
import { QueryKey, UseSuspenseQueryResult } from "@tanstack/react-query";

export function withErrorThrowing<TData, TError = ApiErrorDTO>(
  queryFunction: UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
) {
  const { error, isFetching } = queryFunction;

  if (error && !isFetching) {
    throw error;
  }

  return queryFunction;
}
